<ng-container *ngIf="{ request: invoiceRequest$ | async } as content">
  <div class="page-title simple-card">  
		<page-title [isBackButtonVisible]="true" [backButtonTitle]="'Back to Invoices'" [backButtonRedirectPage]="'invoices'"></page-title>
  </div>

  @if (!content.request?.isPristine) {
    @if (!content.request?.isLoading) {
      @if (!content.request?.hasError) {
        @if (content.request) {


          <div class="m-t-40 h4 row">
            <div class="col-12 col-md-3">
              <div class="item">
                <span class="sub-title">{{ 'invoice.details.invoiceNumber' | cxTranslate }}: </span>
                <span class="value">{{ content.request?.invoice?.invoiceNumber }}</span>
              </div>
            </div>

            <div class="col-12 col-md-3">
              <div class="item">
                <span class="sub-title">{{ 'invoice.details.invoiceDate' | cxTranslate }}: </span>
                <span class="value">{{ content.request?.invoice?.invoiceDate }}</span>
              </div>
            </div>
          </div>

          <div class="m-t-40 h4 row">
            <div class="col-12 col-md-3">
              <div class="item">
                <span class="sub-title">{{ 'invoice.details.accountName' | cxTranslate }}: </span>
                <span class="value">{{ content.request?.invoice?.accountName }}</span>
              </div>
            </div>

            <div class="col-12 col-md-3">
              <div class="item">
                <span class="sub-title">{{ 'invoice.details.invoiceTotal' | cxTranslate }}: </span>
                <span class="value">{{ content.request?.invoice?.invoiceTotal?.formattedValue }}</span>
              </div>
            </div>

            <div class="col-12 col-md-3 ml-auto" *ngIf="!content.request?.isLoading">
              <button type="button" class="btn btn-secondary btn-sm w-100" (click)="exportInvoice()">
                <span class="material-symbols-outlined d-flex m-r-4"> download </span>
                {{ 'exportEntries.exportToExcel' | cxTranslate }}
              </button>
            </div>
          </div>

          <div class="m-t-40 row">
            <div class="col-12 col-md-3">
              <div class="review-summary">
                <div class="cx-review-summary-card simple-card">
                  <div class="w-100">
                    <p class="title m-0 d-flex v-center">
                      <span class="material-symbols-outlined icon"> price_check </span>
                      <span class="m-b-0">{{ 'invoice.details.billTo' | cxTranslate }}</span>
                    </p>
                  </div>
                  <div class="item">
                    <span class="value" [innerHTML]="content.request?.invoice?.billToAddress"></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-3 m-t-sm-10">
              <div class="review-summary">
                <div class="cx-review-summary-card simple-card">
                  <div class="w-100">
                    <p class="title m-0 d-flex v-center">
                      <span class="material-symbols-outlined icon"> local_shipping </span>
                      <span class="m-b-0">{{ 'invoice.details.shipTo' | cxTranslate }}</span>
                    </p>
                  </div>
                  <div class="item">
                    <span class="value" [innerHTML]="content.request?.invoice?.shipToAddress"></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-3">
              <div class="review-summary">
                <div class="cx-review-summary-card simple-card">
                  <div class="w-100">
                    <p class="title m-0 d-flex v-center">
                      <span class="material-symbols-outlined icon"> person </span>
                      <span class="m-b-0">{{ 'invoice.details.remitTo' | cxTranslate }}</span>
                    </p>
                  </div>
                  <div class="item">
                    <span class="value" [innerHTML]="content.request?.invoice?.remitToAddress"></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-3">
              <div class="review-summary">
                <div class="cx-review-summary-card simple-card">
                  <div class="w-100">
                    <p class="title m-0 d-flex v-center">
                      <span class="material-symbols-outlined icon"> request_quote </span>
                      <span class="m-b-0">{{ 'invoice.details.invoicePricingSummary' | cxTranslate }}</span>
                    </p>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'invoice.details.lineTotal' | cxTranslate }}: </span>
                    <span class="value float-right">
                      {{ content.request?.invoice?.invoicePriceSummary?.totalLines?.formattedValue }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'invoice.details.shipping' | cxTranslate }}:</span>
                    <span class="value float-right">
                      {{ content.request?.invoice?.invoicePriceSummary?.shipping?.formattedValue }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'invoice.details.tax' | cxTranslate }}:</span>
                    <span class="value float-right">
                      {{ content.request?.invoice?.invoicePriceSummary?.tax?.formattedValue }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'invoice.details.total' | cxTranslate }}:</span>
                    <span class="value float-right">
                      {{ content.request?.invoice?.invoicePriceSummary?.total?.formattedValue }}
                    </span>
                  </div>

                  <div class="item">
                    <span class="sub-title">{{ 'invoice.details.dueDate' | cxTranslate }}:</span>
                    <span class="value float-right">
                      {{ content.request?.invoice?.invoicePriceSummary?.dueDate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

  <table class="table-responsive table-md m-t-20">
    <thead>
      <tr>
        <th>{{ 'invoice.details.order' | cxTranslate }}</th>
        <th>{{ 'invoice.details.customerPO' | cxTranslate }}</th>
        <th>{{ 'invoice.details.paymentTerm' | cxTranslate }}</th>
        <th>{{ 'invoice.details.invoiceCurrency' | cxTranslate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <span class="responsive-title"> {{ 'invoice.details.order' | cxTranslate }}: </span>
					<a [routerLink]="['/my-account/order', content.request?.invoice?.orderUid]" class="text-underline" target="_blank">
						{{ content.request?.invoice?.orderNumber }}
					</a>
        </td>

        <td>
          <span class="responsive-title"> {{ 'invoice.details.customerPO' | cxTranslate }}: </span>
					<a [routerLink]="['/my-account/orders']" class="text-underline">
						{{ content.request?.invoice?.customerPONumber }}
					</a>
        </td>

              <td>
                <span class="responsive-title"> {{ 'invoice.details.paymentTerm' | cxTranslate }}: </span>
                {{ content.request?.invoice?.paymentTerm }}
              </td>

              <td>
                <span class="responsive-title"> {{ 'invoice.details.invoiceCurrency' | cxTranslate }}: </span>
                {{ content.request?.invoice?.currencyCode }}
              </td>
            </tr>
            </tbody>
          </table>

          <table class="table-responsive table-md m-t-20">
            <thead>
            <tr>
              <th>{{ 'invoice.details.salesPerson' | cxTranslate }}</th>
              <th>{{ 'invoice.details.dateShipped' | cxTranslate }}</th>
              <th>{{ 'invoice.details.carrier' | cxTranslate }}</th>
              <th>{{ 'invoice.details.trackingInfo' | cxTranslate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <span class="responsive-title"> {{ 'invoice.details.salesPerson' | cxTranslate }}: </span>
                {{ content.request?.invoice?.salesRepName }}
              </td>

              <td>
                <span class="responsive-title"> {{ 'invoice.details.dateShipped' | cxTranslate }}: </span>
                {{ content.request?.invoice?.shipDate }}
              </td>

              <td>
                <span class="responsive-title"> {{ 'invoice.details.carrier' | cxTranslate }}: </span>
                {{ content.request?.invoice?.carrier }}
              </td>

              <td>
                <span class="responsive-title"> {{ 'invoice.details.trackingInfo' | cxTranslate }}: </span>
                <div [innerHTML]="content.request?.invoice?.trackingInfo"></div>
              </td>
            </tr>
            </tbody>
          </table>

          @if (content?.request?.invoice?.lines?.length) {
            <table class="table-responsive table-md m-t-20">
              <thead>
                <tr>
                  <th>{{ 'invoice.details.line' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.qtyOrdered' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.qtyShipped' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.uom' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.part' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.catalog' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.customerPart' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.netPrice' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.extPrice' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.tariff' | cxTranslate }}</th>
                    <th>{{ 'invoice.details.poLineNumber' | cxTranslate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let line of content?.request?.invoice?.lines">
                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.line' | cxTranslate }}: </span>
                        {{ line?.lineNumber }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.qtyOrdered' | cxTranslate }}: </span>
                        {{ line?.quantityOrdered }}
                    </td>

                    <td>
                      <span class="responsive-title"> >{{ 'invoice.details.qtyShipped' | cxTranslate }}: </span>
                        {{ line?.quantityShipped }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.uom' | cxTranslate }}: </span>
                        {{ line?.uom }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.part' | cxTranslate }}: </span>
                        {{ line?.partNumber }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.catalog' | cxTranslate }}: </span>
                        {{ line?.catalogNumber }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.customerPart' | cxTranslate }}: </span>
                        {{ line?.customerPartNumber }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.netPrice' | cxTranslate }}: </span>
                        {{ line?.sellingPrice?.formattedValue }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.extPrice' | cxTranslate }}: </span>
                        {{ line?.total?.formattedValue }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.tariff' | cxTranslate }}: </span>
                        {{ line?.tariff }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'invoice.details.poLineNumber' | cxTranslate }}: </span>
                        {{ line?.poLineNumber }}
                    </td>
                  </tr>
                </tbody>
              </table>
              } @else {
                <p class="text-center ff-bold m-t-40">{{ 'invoice.details.noLinesAvailable' | cxTranslate }}</p>
              }
            }
          }
    } @else {
      <div class="loader w-100 m-t-20">
        <local-loader></local-loader>
      </div>
    }
  }

</ng-container>
